import {LOCAL_DEFAULT_USER_ID} from './userConstants';

let activeUserId = LOCAL_DEFAULT_USER_ID;

export const getActiveUserId = () => activeUserId;

/** Called after login / logout / account switch (future Supabase session). */
export const setActiveUserId = userId => {
  if (userId) {
    activeUserId = userId;
  }
};

export const resetActiveUserToLocal = () => {
  activeUserId = LOCAL_DEFAULT_USER_ID;
};
